import { CanisterInfo } from '@plug-core/idls/topUp/topUp'
import { Box, Card, CardActions, CardContent, IconButton, Stack, Typography } from '@mui/material'
import React, { FC } from 'react'
import { FaPen, FaTrash } from 'react-icons/fa6'
import { useTranslation } from 'react-i18next'
import { formatNumber } from '@plug-core/utils/formatNumber'

interface Props {
  canister: CanisterInfo
  onCanisterDelete: () => void
  onCanisterUpdate: () => void
}

const CanisterCard: FC<Props> = ({ canister, onCanisterDelete, onCanisterUpdate }) => {
  const { t } = useTranslation()

  return (
    <>
      <Box key={canister.id.toString()}>
        <Card
          sx={{
            borderRadius: '12px',
            borderTopWidth: '6px',
            borderTopStyle: 'solid',
            borderTopColor: canister.is_healthy ? 'success.main' : 'error.main',
          }}
        >
          <CardContent sx={{ pb: 1 }}>
            <Typography title={canister.name} color="text.primary" mb={1}>
              {canister.name}
            </Typography>
            <Typography color="text.secondary">
              {canister.auto_topup
                ? t('topup.canisterCard.cyclesLeft', {
                    cycles: formatNumber(Number(canister.cycles_left)),
                  })
                : t('topup.canisterCard.autoTopupOff')}
            </Typography>
          </CardContent>
          <CardActions
            sx={{
              justifyContent: 'flex-end',
              px: 2,
              pb: 1.5,
              pt: 0,
            }}
          >
            <Stack direction="row" spacing={1}>
              <IconButton size="small" color="primary" onClick={onCanisterUpdate}>
                <FaPen fontSize="small" />
              </IconButton>
              <IconButton size="small" color="error" onClick={onCanisterDelete}>
                <FaTrash fontSize="small" />
              </IconButton>
            </Stack>
          </CardActions>
        </Card>
      </Box>
    </>
  )
}

export default CanisterCard
